$(document).ready(function () {
    $('.modal').modal('show');
});

Date.prototype.addHours = function (h) {
    //this.setHours(this.getHours() + h);
    this.setTime(this.getTime() + (h * 60 * 60 * 1000));
    return this;
};

function insertString(a, at) {
    var start = 1,
    tokens = a.split(at);

    var temp = '';

    if (tokens[2]) {
        temp = "<div class='col-md-6'>" + tokens[1] + "</div><div class='col-md-6'>" + tokens[2] + "</div>";
    } else if (tokens[1]) {
        temp = "<div class='col-md-6'>" + tokens[1] + "</div><div class='col-md-6'></div>";
    } else {
        temp = "<div class='col-md-6'></div><div class='col-md-6'></div>";
    }

    return temp;
}

function addZero(i) {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}

function getHours(h, date) {
    //h = '10:00, 11:00, 12:00, 10:30, 11:30, 12:30'
    var hours = h.split(',');

    var newDates = _.map(hours, function (hour) {
        return newDate = new Date('01/01/2011 ' + hour);
    });

    newDates.sort(function (a, b) {
        return a - b;
    });

    hours = _.map(newDates, function (date) {
        return newDate = moment(date).format('HH:mm');
    });

    if (infoData.Country.indexOf('enu') > -1 || infoData.Country.indexOf('ius') > -1) {
        hours = getUSHours(hours);
    }
    return hours;
}

function getHoursArr(h, date) {

    var hours = h;

    var newDates = _.map(hours, function (hour) {
        return newDate = new Date('01/01/2011 ' + hour);
    });

    newDates.sort(function (a, b) {
        return a - b;
    });

    hours = _.map(newDates, function (date) {
        return newDate = moment(date).format('HH:mm');
    });

    if (infoData.Country.indexOf('enu') > -1 || infoData.Country.indexOf('ius') > -1) {
        hours = getUSHours(hours);
    }
    return hours;
}

function getUSHours(hours) {
    return _.map(hours, function (hour) {
        return moment(hour, 'HH:mm').format('hh:mm a');
    });
}

function parseLocation(location) {
    var pairs = location.substring(1).split("&");
    var obj = {};
    var pair;
    var i;

    for (i in pairs) {
        if (pairs[i] === "") continue;

        pair = pairs[i].split("=");
        obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    return obj;
}

var params = parseLocation(window.location.search);

function reload() {
    location.reload();
}

function getTime(h) {
    var timeArea = '';
    var t = '';

    if (h.indexOf('am') > -1) {
        timeArea = 'am';
    } else if(h.indexOf('pm') > -1){
        timeArea = 'pm';
    } 

    var time = h.substring(0, 5);
    time = time.split(":");

    if(timeArea != 'pm'){
       t = time[0] + ":" + time[1];
    } else if (timeArea == 'pm') {
        if (parseInt(time[0]) == 12)
           time[0] = 0;

        time[0] = parseInt(time[0]) + 12;
        t = time[0] + ":" + time[1];
    }

    return t;
}

function formatInvitationLinks(l) {
    if(l != null )
        var links = l.split(',');

    return links;
}
